export default {
    GET_COSTPACKAGE: "[zina_flow][costpackage] get all costpackage",
    GET_COSTPACKAGE_SUCCESS: "[zina_flow][costpackage] get all costpackage SUCCESS",
    GET_COSTPACKAGE_FAIL: "[zina_flow][costpackage] get all costpackage FAIL",
    UPDATE_PAGINATION: "[zina_flow][costpackage] update costpackage pagination",
    CHANGE_PAGE: "[zina_flow][costpackage] change costpackage page",
    FILTER_LIST: "[zina_flow][costpackage] change costpackage filters",
    GET_COSTPACKAGE_DETAIL: "[zina_flow][costpackage] get costpackage detail",
    GET_COSTPACKAGE_DETAIL_SUCCESS: "[zina_flow][costpackage] get costpackage detail SUCCESS",
    GET_COSTPACKAGE_DETAIL_FAIL: "[zina_flow][costpackage] get costpackage detail FAIL"
};
